import moment from 'moment';

/**
 * Wellness calendar event tile (Aayuv DS overview 2a):
 * - live/upcoming: left 76px date block (mono day over month), green participants line
 * - completed: plain bordered tile, gray participants line
 * The date block is skipped when event_date can't be parsed.
 */
const WellnessCalendarUtilizationCard = ({ title = '', date = '', time = '', participants, classes = '', tone = 'done' }) => {
  const isLive = tone === 'live';
  const parsedDate = moment(date, [moment.ISO_8601, 'MMM DD, YYYY', 'DD MMM YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY'], false);
  const showDateBlock = isLive && parsedDate.isValid();

  return (
    <div className={`flex items-stretch overflow-hidden rounded-[10px] border border-gray-300 bg-white ${classes}`}>
      {showDateBlock && (
        <div className='flex w-[76px] shrink-0 flex-col items-center justify-center border-r border-gray-300 bg-gray-50'>
          <span className='font-jetbrains-mono text-lg font-semibold leading-tight tabular-nums text-gray-900'>{parsedDate.format('DD')}</span>
          <span className='text-[10px] font-semibold uppercase tracking-[.08em] text-gray-600'>{parsedDate.format('MMM')}</span>
        </div>
      )}
      <div className='min-w-0 px-3.5 py-3'>
        <h2 className='mb-0 text-[13px] font-semibold text-gray-900' style={{ lineHeight: 1.3 }}>{title}</h2>
        <p className='mb-0 mt-1 text-xs text-gray-600'>{`${date} · ${time}`}</p>
        <p
          className={`mb-0 mt-1.5 text-xs leading-relaxed ${isLive ? 'font-medium' : ''}`}
          style={{ color: isLive ? '#0E6354' : '#6B7280' }}
        >
          <span className='font-jetbrains-mono tabular-nums'>{participants}</span> participants joined
        </p>
      </div>
    </div>
  );
};

export default WellnessCalendarUtilizationCard
